import React from "react";

function SvgIcMapPoi101(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M17 21.997h4v-4h-4v4zm-6 0h4v-4h-4v4zm13-6v10.036H8V15.997h16zm1-4v2H7v-2h18zm-5.845-7.863a.5.5 0 01.707.707L17.453 7.25 20 9.797a4.101 4.101 0 01-5.799-5.8l2.545 2.546z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi101;
